import { HiMoon, HiSun } from 'react-icons/hi'
import { useDarkMode } from './Theme.hook'
import { ToggleButton } from './ThemeToggle.styles'

const ThemeToggle = () => {
  const { theme, toggleTheme } = useDarkMode()
  const isDark = theme === 'dark'

  return (
    <ToggleButton
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
      aria-pressed={isDark}
      title={isDark ? 'Modo claro' : 'Modo oscuro'}
    >
      {isDark ? <HiSun aria-hidden /> : <HiMoon aria-hidden />}
    </ToggleButton>
  )
}

export default ThemeToggle
